<template>
  <map-view-grid-main />
</template>

<script>
/**
 * 4画面マップ全体のコンポーネント
 */
import MapViewGridMain from "@/components/templates/MapViewGridMain";
export default {
  name: "P.MapView",
  components: {
    MapViewGridMain,
  },
};
</script>

<style lang="scss"></style>
